import type { UnlockErrorCode } from './api'

interface UnlockMessages {
    title: string
    description: string
    label: string
    submit: string
    pending: string
    checking: string
    retry: string
    show: string
    hide: string
    folder: string
    errors: Record<UnlockErrorCode, string>
}

const ru: UnlockMessages = {
    title: 'Защищённое хранилище',
    description: 'Введите пароль шифрования, чтобы открыть файлы.',
    label: 'Пароль шифрования',
    submit: 'Открыть хранилище',
    pending: 'Проверяем пароль…',
    checking: 'Проверяем доступ…',
    retry: 'Попробовать ещё раз',
    show: 'Показать пароль',
    hide: 'Скрыть пароль',
    folder: 'Папка',
    errors: {
        empty: 'Введите пароль шифрования.',
        rejected:
            'Не удалось разблокировать хранилище. Проверьте пароль и доступ к этой папке.',
        access: 'Доступ запрещён. Проверьте доступ к хранилищу или войдите заново.',
        rateLimited: 'Слишком много запросов. Попробуйте позже.',
        unavailable:
            'Не удалось связаться с хранилищем или проверить ответ. Попробуйте ещё раз.',
    },
}

const en: UnlockMessages = {
    title: 'Protected storage',
    description: 'Enter the encryption password to access your files.',
    label: 'Encryption password',
    submit: 'Open storage',
    pending: 'Checking password…',
    checking: 'Checking access…',
    retry: 'Try again',
    show: 'Show password',
    hide: 'Hide password',
    folder: 'Folder',
    errors: {
        empty: 'Enter the encryption password.',
        rejected:
            'Unable to unlock storage. Check your password and access to this folder.',
        access: 'Access denied. Check your storage access or sign in again.',
        rateLimited: 'Too many requests. Please try again later.',
        unavailable:
            'Unable to reach storage or verify its response. Please try again.',
    },
}

export const unlockMessages = { ru, en }
